import styled, { css } from "styled-components";
import { breakpoints } from "root/libs/ui-styleguide/src";

export const uniDimensionalContainer = css`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const biDimensionalContainer = css`
  @media screen and (min-width: ${breakpoints.desktop}) {
    max-width: 100rem;
  }

  @supports (display: grid) {
    max-width: auto;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-gap: calc(var(--dui-size-space-5x) + var(--dui-size-space-1));

    @media screen and (min-width: ${breakpoints.tablet}) {
      grid-gap: var(--dui-size-space-10x);
      grid-template-columns: repeat(
        12,
        calc(var(--dui-size-space-10x) + var(--dui-size-space-5x))
      );
    }

    @media screen and (min-width: ${breakpoints.desktop}) {
      grid-gap: calc(var(--dui-size-space-10x) + var(--dui-size-space-5x));
      grid-template-columns: repeat(
        12,
        calc(
          var(--dui-size-space-20x) + var(--dui-size-space-16x) +
            var(--dui-size-space-1)
        )
      );
    }
  }
`;

export const StyledGridContainer = styled.div`
  margin-bottom: ${(props) => props.bottomSpacing[0]};
  justify-content: ${(props) => props.gridJustifyContent};
  ${(props) =>
    props.gridDimension === "uniDimensional"
      ? uniDimensionalContainer
      : biDimensionalContainer};
  ${(props) =>
    props.halfGutterPadding
      ? "padding-left: var(--dui-size-space-20x); padding-right: var(--dui-size-space-20x);"
      : ""}

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin-bottom: ${(props) => props.bottomSpacing[1]};
  }

  @supports (display: grid) {
    @media screen and (min-width: ${breakpoints.tablet}) {
      padding-left: calc(var(--dui-size-space-10x) + var(--dui-size-space-5x));
      padding-right: calc(var(--dui-size-space-10x) + var(--dui-size-space-5x));
    }

    @media screen and (min-width: ${breakpoints.desktop}) {
      padding-left: calc(var(--dui-size-space-20x) + var(--dui-size-space-20x));
      padding-right: calc(var(--dui-size-space-20x) + var(--dui-size-space-20x));
    }
  }

  @media print {
    & > button {
      display: none;
    }
  }
`;

export const biDimemsionalCell = css`
  @supports (display: grid) {
    grid-column-end: span
      ${(props) => (props.spanMobile ? props.spanMobile : 12)};
    grid-column-start: ${(props) =>
      props.columnStartMobile ? props.columnStartMobile : 1};

    @media screen and (min-width: ${breakpoints.tablet}) {
      grid-column-end: span
        ${(props) => (props.spanTablet ? props.spanTablet : 12)};
      grid-column-start: ${(props) =>
        props.columnStartTablet ? props.columnStartTablet : 1};
    }

    @media screen and (min-width: ${breakpoints.desktop}) {
      grid-column-end: span
        ${(props) => (props.spanDesktop ? props.spanDesktop : 5)};
      grid-column-start: ${(props) =>
        props.columnStart ? props.columnStart : 2};
      ${(props) =>
        props.gridColumn ? `grid-column: ${props.gridColumn}` : ""};
    }
  }
`;

export const containerPadding = css`
  @media screen and (min-width: ${breakpoints.desktop}) {
    padding-left: calc(var(--dui-size-space-20x) + var(--dui-size-space-20x));
    padding-right: calc(var(--dui-size-space-20x) + var(--dui-size-space-20x));
  }
`;

function percent(value, maxValue) {
  return (value * 100) / maxValue;
}
const columnPlusGutter = 103;
const maxWidthNumber = 1365;
export const cell = {
  uniDimensional: (span, startColumn = 0) => `
    box-sizing: border-box;
    flex-grow: 1;
    flex-basis: 100%;
    padding-right: var(--dui-size-space-10x);
    max-width: 100%;

    @media screen and (min-width: ${breakpoints.tablet}) {
      padding-right: calc(var(--dui-size-space-20x) + var(--dui-size-space-16x) + var(--dui-size-space-1)) !important;
      max-width: ${percent(span * columnPlusGutter, maxWidthNumber)}%;
      margin-left: ${startColumn * columnPlusGutter}px !important;
    }
  `,
};

export const containerPaddingML = css`
  @media screen and (min-width: ${breakpoints.tablet}) {
    padding-left: calc(var(--dui-size-space-10x) + var(--dui-size-space-5x));
    padding-right: calc(var(--dui-size-space-10x) + var(--dui-size-space-5x));
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    padding-left: calc(var(--dui-size-space-20x) + var(--dui-size-space-20x));
    padding-right: calc(var(--dui-size-space-20x) + var(--dui-size-space-20x));
  }
`;
